module.exports = __webpack_public_path__ + "eed8afe29dca201a377ce6e3b299c589.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Italic-webfont.svg
// module id = 73
// module chunks = 0